import { atomFamily } from 'recoil';

const TooltipNotificationAtom = atomFamily<boolean, string>({
    key: 'tooltip-notification',
    default: false
});

export default TooltipNotificationAtom;
